import { render, staticRenderFns } from "./TemplateCategoryDetail.vue?vue&type=template&id=d63797ba"
import script from "./TemplateCategoryDetail.vue?vue&type=script&lang=js"
export * from "./TemplateCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports